import { connect } from 'react-redux'

import { loadInProgressWorkSummaries, loadPendingArchivedWorkSummaries } from '../../actions/work-summaries'
import { inProgressSelector, pendingApprovalSelector, archiveSelector } from '../../selectors/work-summary-selectors'

import WorkSummaries from '../../components/work-summaries/work-summaries'
import { readInProgressNotifications } from '../../actions/auth'
import throttle from 'lodash/throttle'

function mapStateToProps (state, ownProps) {
  const pagination = state.pagination.workSummaries
  const pathname = ownProps.location.pathname
  const inProgressOnly = pathname === 'in-progress'

  let componentState = {
    pathname,
    hasNextPage: pagination.nextPageUrl
  }

  if (inProgressOnly) {
    componentState.inProgress = inProgressSelector(state)
  } else {
    componentState.pendingApproval = pendingApprovalSelector(state),
    componentState.archive = archiveSelector(state)
  }

  return componentState
}

function mapDispatchToProps (dispatch, ownProps) {
  const pathname = ownProps.location.pathname

  if (pathname === 'in-progress') {
    dispatch(loadInProgressWorkSummaries(''))
    dispatch(readInProgressNotifications())
  } else {
    dispatch(loadPendingArchivedWorkSummaries(''))
  }

  let searchQuery = ''

  const loadFirstPageThrottled = throttle(
    () => {
      if(searchQuery.length !== 0 && searchQuery.length < 3) return
      if (pathname === 'in-progress') {
        dispatch(loadInProgressWorkSummaries(searchQuery))
      } else {
        dispatch(loadPendingArchivedWorkSummaries(searchQuery))
      }
    }, 250
  )

  return {
    onLoadNextPage () {
      if (pathname === 'in-progress') {
        dispatch(loadInProgressWorkSummaries('', true))
      } else {
        dispatch(loadPendingArchivedWorkSummaries('', true))
      }
    },
    onLoadFirstPage (search) {
      searchQuery = search
      loadFirstPageThrottled()
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkSummaries)



// WEBPACK FOOTER //
// ./src/containers/work-summaries/work-summaries-container.js